// src/routes/accountRoutes.jsx
import React from "react";
import { Route } from "react-router-dom";
import AccountLayout from "../component/Account/AccountLayout";
import AccountTab from "../component/Account/tabs/AccountTab";
import OrdersTab from "../component/Account/tabs/OrdersTab";
import NotificationsTab from "../component/Account/tabs/NotificationsTab";
import DepositTab from "../component/Account/tabs/DepositTab";
import WishlistTab from "../component/Account/tabs/WishlistTab";
import ProtectedRoute from "./ProtectedRoute";

export const accountRoutes = (
  <Route element={<ProtectedRoute />}>
    <Route path="/account" element={<AccountLayout />}>
      <Route index element={<AccountTab />} />
      <Route path="orders" element={<OrdersTab />} />
      <Route path="notifications" element={<NotificationsTab />} />
      <Route path="deposit" element={<DepositTab />} />
      <Route path="wishlist" element={<WishlistTab />} />
    </Route>
  </Route>
);
